import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndeterminateHorizontalProgressIndicatorComponent } from '@shared/components/indeterminate-horizontal-progress-indicator/indeterminate-horizontal-progress-indicator.component';

@Injectable({
	providedIn: 'root'
})
export class LoadingOverlayService {

	private _fullscreenProgressOverlayRef?: OverlayRef;

	constructor (
		private _overlay: Overlay,
		private _translate: TranslateService
	) { }


	showIndeterminateHorizontalProgressIndicator(messageTranslationKey: string = ""): void {

		const translationKey = messageTranslationKey || "APP_NOTIFICATIONS.PLEASE_WAIT_MESSAGE";

		this._fullscreenProgressOverlayRef = this._overlay.create({
			positionStrategy: this._overlay.position().global().centerHorizontally().centerVertically(),
			hasBackdrop: true
		});

		const componentRef = this._fullscreenProgressOverlayRef?.attach(new ComponentPortal(IndeterminateHorizontalProgressIndicatorComponent));
		if (componentRef) {
			this._translate.get(translationKey).subscribe((msg: string) => componentRef.instance.displayString = msg);
		}
	}

	hide(): void {
		this._fullscreenProgressOverlayRef?.detach();
		this._fullscreenProgressOverlayRef = undefined;
	}
}
